import axios from '../../axios'

export const state = {
  tableData: {
    data: [],
    currentPage: 1,
    perPage: 10,
    search: '',
    sortBy: 'id',
    sortDesc: true,
    totalRows: 1,
    isFetched: false,
    state: null,
  },
}

export const actions = {
  index({ state, commit }, { params }) {
    return new Promise((resolve, reject) => {
      const defaultParams = {
        search: state.tableData.search,
        page: state.tableData.currentPage,
        size: state.tableData.perPage,
        order_key: state.tableData.sortBy,
        order_by: state.tableData.sortDesc ? 'desc' : 'asc',
      }

      if (params && typeof params === 'object') {
        console.log(params)
      }
      console.log(state.tableData.state)

      if (state.tableData.state != null) {
        defaultParams.state = state.tableData.state.id
      }

      if (!state.tableData.isFetched) {
        axios
          .get('transfer-requests', { params: defaultParams })
          .then((res) => {
            commit('SET_DATA', { responseData: res.data })
            resolve(res)
          })
          .catch((er) => {
            reject(er)
          })
      } else {
        resolve()
      }
    })
  },
}

export const mutations = {
  SET_DATA(state, payload) {
    state.tableData = payload.tableDetail
    state.tableData.data = payload.responseData.data
    state.tableData.totalRows = payload.responseData.data.total
  },
}
